import {money} from "../../Utility/filters/money";
import {percentage} from "../../Utility/filters/number";

export const displayAdjustment = (bundleBookingRule) => {
    let amount = bundleBookingRule.adjustment_type === 'percentage'
        ? percentage(bundleBookingRule.percentage_amount)
        : money(bundleBookingRule.absolute_amount, 'GBP');

    return `the price of each of those participants will ${bundleBookingRule.adjustment_direction} by ${amount}.`;
}



// WEBPACK FOOTER //
// ./src/Assets/components/BundleBookingRules/filters/display_adjustment.js